<template>
  <BaseButton primary outline small class="w-full" @click="viewMessages">
    View Messages
  </BaseButton>
</template>

<script>
export default {
  props: {
    projectAsset: {
      type: Object,
      required: true,
    },
  },
  methods: {
    viewMessages() {
      this.$modal.show({
        component: 'ViewProjectAssetRejectCommentsModal',
        props: {
          projectAssetId: this.projectAsset.id,
        },
        on: {},
        hideEvent: 'closed',
      });
    },
  },
};
</script>
